import React from "react";
import { FormControl, InputLabel, Select, MenuItem, Grid, Typography, Box } from "@mui/material";

const TimeSelectComponent = ({ onTimeChange, hoursIn, hoursOut, minutesIn, minutesOut }) => {
  const containerStyle = {
    display: "flex",
    gap: "16px",
    justifyContent: "center",
    padding: "16px",
  };

  const sectionStyle = {
    display: "flex",
    gap: "8px",
    padding: "8px 16px",
    borderRadius: "8px",
    "@media (max-width: 760px)": {
      flexDirection: "column",
      alignItems: "flex-start",
    },
  };

  const labelStyle = {
    fontSize: "0.4rem",
    textAlign: "center",
  };

  const selectContainerStyle = {
    display: "flex",
    gap: "8px",
    alignItems: "center",
    "@media (max-width: 760px)": {
      flexDirection: "column",
      alignItems: "flex-start",
    },
  };

  const selectStyle = {
    width: "30px",
    "& .MuiSelect-select": {
      padding: "4px",
      fontSize: "0.9rem",
    },
  };

  const titleStyle = {
    fontSize: "0.9rem",
    color: "black",
    fontWeight: 500,
    marginBottom: "4px",
  };

  return (
    <Box sx={containerStyle}>
      {/* Sección Antes */}
      <Box sx={sectionStyle}>
        <Typography sx={titleStyle}>Antes:</Typography>
        <Box sx={selectContainerStyle}>
          <FormControl variant="standard" size="small">
            <InputLabel sx={labelStyle}>Hrs</InputLabel>
            <Select
              value={hoursIn}
              onChange={(e) => onTimeChange("check_in_time", e.target.value)}
              sx={selectStyle}
            >
              {Array.from({ length: 7 }, (_, index) => (
                <MenuItem key={index} value={index}>
                  {index < 10 ? `0${index}` : index}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl variant="standard" size="small">
            <InputLabel sx={labelStyle}>Min</InputLabel>
            <Select
              value={minutesIn}
              onChange={(e) => onTimeChange("check_in_minute", e.target.value)}
              sx={selectStyle}
            >
              {Array.from({ length: 60 }, (_, index) => (
                <MenuItem key={index} value={index}>
                  {index < 10 ? `0${index}` : index}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
      </Box>

      {/* Sección Después */}
      <Box sx={sectionStyle}>
        <Typography sx={titleStyle}>Después:</Typography>
        <FormControl variant="standard" size="small">
          <InputLabel sx={labelStyle}>Hrs</InputLabel>
          <Select
            value={hoursOut}
            onChange={(e) => onTimeChange("check_out_time", e.target.value)}
            sx={selectStyle}
          >
            {Array.from({ length: 7 }, (_, index) => (
              <MenuItem key={index} value={index}>
                {index < 10 ? `0${index}` : index}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl variant="standard" size="small">
          <InputLabel sx={labelStyle}>Min</InputLabel>
          <Select
            value={minutesOut}
            onChange={(e) => onTimeChange("check_out_minute", e.target.value)}
            sx={selectStyle}
          >
            {Array.from({ length: 60 }, (_, index) => (
              <MenuItem key={index} value={index}>
                {index < 10 ? `0${index}` : index}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
    </Box>
  );
};

export default TimeSelectComponent;
